export const LenElectronicsTitl = () => {
  return [
    "Fjallraven - рюкзак Foldsack № 1, вміщує 15 ноутбуків",
    "Чоловічі повсякденні приталені футболки преміум-класу5",
    "Чоловіча бавовняна куртка",
    "Чоловічий повсякденний приталений",
    "Браслет-ланцюжок John Hardy Legends Naga Gold & Silver Dragon Station",
    "Мікропрокладка Solid Gold Petite",
    "Принцеса з білим золотом",
    "Подвійна сова з нержавіючої сталі з рожевим золотом",
    "Портативний зовнішній жорсткий диск WD Elements ємністю 2 ТБ -USB 3.0",
    "SanDisk SSD PLUS 1 ТБ Внутрішній твердотільний накопичувач -SATA III 6 Гбіт/с",
    "Silicon Power 256 ГБ SSD 3D NAND A55 SLC Cache Підвищення продуктивності SATA III 2.5",
    "Ігровий накопичувач WD 4 ТБ сумісний з портативним зовнішнім жорстким диском Playstation 4",
    "Acer SB220Q bi 21,5 дюйма Full HD (1920 x 1080) IPS Ultra-Thin",
    "49-дюймовий вигнутий ігровий монітор Samsung CHG90 144 Гц (LC49HG90DMNXZA) -надширокий екран QLED",
    "BIYLACLESEN Жіноча зимова куртка 3 в 1 для сноуборду",
    "Жіноча байкерська куртка зі знімним капюшоном зі штучної шкіри Lock and Love",
    "Дощовик. Жіноча вітрівка. Смугасті плащі для скелелазіння",
    "Жіноча однотонна футболка з коротким рукавом MBJ V",
    "Жіноча футболка з коротким рукавом Opna",
    "Жіноча футболка DANVOUY Casual Cotton Short",
  ];
};
